document.addEventListener("DOMContentLoaded", () => {
    const FREE_SHIP_THRESHOLD = 25;

    const PRICE_VARIANTS = {
        material: [
            { value: "Black", price: 4.99 },
            { value: "Clear", price: 4.95 },
            { value: "Holographic", price: 4.95 },
        ],

        upgrade_material_basic: [
            { value: "Gloss", price: 0 },
            { value: "Matte", price: 5.0 },
            { value: "Pro-Max-DOUBLE THICKNESS-7 YR DURABILITY", price: 10.0 },
        ],

        upgrade_material_holo: [
            { value: "Standard Holographic", price: 0 },
            { value: "Glitter Holographic", price: 5.0 },
            { value: "Prismatic Holographic", price: 10.0 },
        ],

        decal_length: [
            { value: "4 Inches Long VERY SMALL", price: 0.0 },
            { value: "5 Inches Long", price: 3.0 },
            { value: "6 Inches Long", price: 5.99 },
            { value: "7 Inches Long", price: 6.99 },
            { value: "8 Inches Long", price: 7.99 },
            { value: "9 Inches Long", price: 8.99 },
            { value: "10 Inches Long", price: 9.99 },
            { value: "12 Inches Long", price: 11.99 },
            { value: "15 Inches Long", price: 14.99 },
            { value: "20 Inches Long", price: 20.99 },
            { value: "22 Inches Long", price: 22.99 },
            { value: "24 Inches Long", price: 26.99 },
            { value: "25 Inches Long", price: 28.99 },
            { value: "30 Inches Long", price: 36.99 },
            { value: "35 Inches Long", price: 38.99 },
            { value: "40 Inches Long", price: 47.99 },
            { value: "45 Inches Long", price: 40.99 },
            { value: "50 Inches Long", price: 57.99 },
            { value: "55 Inches Long", price: 60.99 },
            { value: "60 Inches Long", price: 67.99 },
            { value: "65 Inches Long", price: 70.99 },
            { value: "70 Inches Long", price: 77.99 },
            { value: "75 Inches Long", price: 80.99 },
            { value: "80 Inches Long", price: 87.99 },
            { value: "85 Inches Long", price: 90.99 },
            { value: "90 Inches Long", price: 97.99 },
            { value: "95 Inches Long", price: 98.99 },
            { value: "100 Inches Long", price: 100.99 },
        ],

        pack_size: [
            { value: "Single", price: 0.0 },
            { value: "2 Pack", price: 7.0 },
            { value: "3 Pack", price: 15.0 },
            { value: "5 Pack", price: 20.0 },
            { value: "10 Pack", price: 15.0 },
            { value: "25 Pack", price: 25.0 },
        ],

        lamination: [
            { value: "No Lamination", price: 0.0 },
            { value: "YES ADD LAM- Recommend if used on cars", price: 10.0 },
        ],

        install_kit: [
            { value: "No install kit", price: 0.0 },
            { value: "Add install kit", price: 5.0 },
        ],
    };

    // Creator Deployment Kit — one set = 8 stickers across 4 sizes. Pricing is
    // derived live from the decal-length + pack-size tables (no fixed amounts).
    const KIT_SET_COMPOSITION = [
        { decal: "20 Inches Long", qty: 1 },
        { decal: "10 Inches Long", qty: 1 },
        { decal: "5 Inches Long", qty: 2 },
        { decal: "4 Inches Long VERY SMALL", qty: 4 },
    ];
    const KIT_STICKERS_PER_SET = 8;
    // Quantity-based discount (decal length does NOT change the rate, only the
    // quantity of that size does). A quantity floors to the nearest lower pack
    // tier; the 25-pack rate is the cap for anything 25+. Rates mirror the
    // effective per-sticker discounts of the pack-size pricing.
    const KIT_DISCOUNT_TIERS = [
        { min: 25, disc: 0.89 },
        { min: 10, disc: 0.8 },
        { min: 5, disc: 0.53 },
        { min: 3, disc: 0.33 },
        { min: 2, disc: 0.27 },
        { min: 1, disc: 0 },
    ];
    const KIT_SET_PROP = {
        1: "1st pack 8 stickers with 4 sizes",
        2: "2nd pack 16 stickers with 4 sizes",
        3: "3rd pack 24 stickers with 4 sizes",
        4: "4th pack 32 stickers with 4 sizes",
    };

    const COLOR_HEX = {
        "Gloss Black": "#0f1111",
        "Gloss White": "#ffffff",
        "Ice Blue": "#21B3DA",
        "Cobalt Blue": "#1A2A99",
        "Brimestone Yellow": "#FDF809",
        Yellow: "#FEDC01",
        "Pastel Orange": "#FF7111",
        "Orange Red": "#F63700",
        Red: "#C70304",
        "Dark Red": "#960B04",
        "Light Gray": "#E3DFE0",
        "Dark Gray": "#818181",
        "Yellow Green": "#52B12F",
        Green: "#049049",
        "Forest Green": "#04370C",
        Purple: "#711953",
        "Soft Pink": "#E66B87",
        "Bright Pink": "#F62B56",
        Cream: "#FBDC81",
        Brown: "#350C06",
    };

    const state = {
        material: "Black",
        platform: "Facebook",
        font: "Anton",
        letter_color: "Gloss Black",
        username: null,
        decal_length: "10 Inches Long",
        pack_size: "5 Pack",
        creator_kit: null,
        upgrade_material: "Gloss",
        lamination: "No Lamination",
        install_kit: "No install kit",
        price: 0,
    };

    const PCSMS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;

    const PCSMS_CART_LOADING_HTML = `<span class="pcsms-cart-loading"><svg class="pcsms-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

    function show(el) {
        el.style.display = "";
    }
    function hide(el) {
        el.style.display = "none";
    }

    function animatePriceChange(targetElement, start, end, duration = 500) {
        let startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = start + (end - start) * progress;
            targetElement.textContent = currentValue.toFixed(2);
            if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    function getOptionDisplayText(optionEl) {
        const textEl = optionEl.querySelector(".pcsms-option-text");
        return textEl ? textEl.textContent.trim() : optionEl.textContent.trim();
    }

    function getFontClass(fontName) {
        const li = document.querySelector(
            `#font-select li[data-value="${CSS.escape(fontName)}"]`
        );
        if (!li) return "font-Anton";
        return [...li.classList].find((cls) => cls.startsWith("font-")) || "font-Anton";
    }

    function getPreviewFontSize() {
        const usernameEl = document.getElementById("pcsms-preview-username");
        if (!usernameEl) return 26;
        return parseFloat(getComputedStyle(usernameEl).fontSize) || 26;
    }

    const CONTOUR_PAD = 14;
    const CONTOUR_OFFSET = 6;
    const CONTOUR_BORDER = 4;
    const CONTOUR_SUPERSAMPLE = 2;

    function getDomBox(el, face, pad) {
        const faceRect = face.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        return {
            x: pad + (rect.left - faceRect.left),
            y: pad + (rect.top - faceRect.top),
            w: rect.width,
            h: rect.height,
        };
    }

    function getSpanDrawY(ctx, font, text, box) {
        ctx.font = font;
        ctx.textBaseline = "alphabetic";
        const metrics = ctx.measureText(text);

        // Match how the browser vertically positions text inside the line box:
        // baseline = lineTop + half-leading + fontAscent, using the font's em metrics
        // (fontBoundingBox*) which are text-independent. This keeps the contour aligned
        // with the visible HTML text across ALL fonts, regardless of their intrinsic
        // ascent/descent or "normal" line-height.
        const fbAscent = metrics.fontBoundingBoxAscent;
        const fbDescent = metrics.fontBoundingBoxDescent;
        if (fbAscent != null && fbDescent != null) {
            const leading = box.h - (fbAscent + fbDescent);
            return box.y + leading / 2 + fbAscent;
        }

        const descent = metrics.actualBoundingBoxDescent ?? 0;
        if (descent > 0) return box.y + box.h - descent;
        return box.y + box.h * 0.82;
    }

    function drawSpanMask(ctx, text, box, font, letterSpacing, fontSize) {
        ctx.font = font;
        ctx.textBaseline = "alphabetic";
        if (letterSpacing) ctx.letterSpacing = letterSpacing;
        const y = getSpanDrawY(ctx, font, text, box);
        ctx.lineJoin = "round";
        ctx.lineCap = "round";
        ctx.lineWidth = Math.max(1, fontSize * 0.04);
        ctx.strokeStyle = "#ffffff";
        ctx.fillStyle = "#ffffff";
        ctx.strokeText(text, box.x, y);
        ctx.fillText(text, box.x, y);
    }

    function buildMaskDrawer(ctx, layout) {
        const {
            icon,
            iconBox,
            atText,
            nameText,
            atBox,
            nameBox,
            handleFont,
            letterSpacing,
            fontSize,
        } = layout;

        return () => {
            ctx.fillStyle = "#ffffff";

            if (icon && icon.complete && icon.naturalWidth) {
                ctx.drawImage(icon, iconBox.x, iconBox.y, iconBox.w, iconBox.h);
            } else {
                roundRect(ctx, iconBox.x, iconBox.y, iconBox.w, iconBox.h, 8);
                ctx.fill();
            }

            drawSpanMask(ctx, atText, atBox, handleFont, letterSpacing, fontSize);
            drawSpanMask(ctx, nameText, nameBox, handleFont, letterSpacing, fontSize);
        };
    }

    function downscaleCanvas(src, destW, destH) {
        const out = document.createElement("canvas");
        out.width = destW;
        out.height = destH;
        const ctx = out.getContext("2d");
        if (!ctx) return src;
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(src, 0, 0, destW, destH);
        return out;
    }

    function dilateMaskUniform(maskCanvas, radiusPx) {
        // True morphological dilation = uniform offset around the silhouette.
        // Stamp the crisp mask along concentric rings so every edge grows by exactly
        // radiusPx, giving equal padding on all sides (a real contour cut, not a blob).
        const w = maskCanvas.width;
        const h = maskCanvas.height;
        const out = document.createElement("canvas");
        out.width = w;
        out.height = h;
        const octx = out.getContext("2d");
        if (!octx) return maskCanvas;

        const r = Math.max(1, radiusPx);
        const rings = Math.max(2, Math.round(r / 4));
        const steps = Math.min(48, Math.max(16, Math.round(r * 1.6)));

        for (let ring = 1; ring <= rings; ring += 1) {
            const rr = (r * ring) / rings;
            for (let i = 0; i < steps; i += 1) {
                const angle = (i / steps) * Math.PI * 2;
                octx.drawImage(
                    maskCanvas,
                    Math.cos(angle) * rr,
                    Math.sin(angle) * rr
                );
            }
        }
        octx.drawImage(maskCanvas, 0, 0);

        return out;
    }

    function buildExpandedMask(layout, bitmapW, bitmapH, canvasW, canvasH, dpr, radius) {
        const ss = CONTOUR_SUPERSAMPLE;
        const scale = dpr * ss;
        const mask = document.createElement("canvas");
        mask.width = Math.ceil(canvasW * scale);
        mask.height = Math.ceil(canvasH * scale);
        const mctx = mask.getContext("2d");
        if (!mctx) return null;

        mctx.setTransform(scale, 0, 0, scale, 0, 0);
        mctx.clearRect(0, 0, canvasW, canvasH);
        buildMaskDrawer(mctx, layout)();

        const expanded = dilateMaskUniform(mask, radius * scale);
        return downscaleCanvas(expanded, bitmapW, bitmapH);
    }

    function getBodyFill(ctx, material, canvasW, canvasH) {
        if (material === "Holographic") {
            const grad = ctx.createLinearGradient(0, 0, canvasW, canvasH);
            grad.addColorStop(0, "#ffd6eb");
            grad.addColorStop(0.16, "#c9b8ff");
            grad.addColorStop(0.33, "#a8f0ff");
            grad.addColorStop(0.5, "#fff3a8");
            grad.addColorStop(0.66, "#ffc4b8");
            grad.addColorStop(0.83, "#d4c4ff");
            grad.addColorStop(1, "#ffd6eb");
            return grad;
        }
        if (material === "Clear") return "#ffffff";
        return "#0f0f0f";
    }

    function makeColoredLayer(mask, fillStyle, canvasW, canvasH, dpr) {
        const layer = document.createElement("canvas");
        layer.width = mask.width;
        layer.height = mask.height;
        const lctx = layer.getContext("2d");
        if (!lctx) return null;

        lctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        lctx.fillStyle =
            typeof fillStyle === "function"
                ? fillStyle(lctx, canvasW, canvasH)
                : fillStyle;
        lctx.fillRect(0, 0, canvasW, canvasH);
        lctx.globalCompositeOperation = "destination-in";
        lctx.setTransform(1, 0, 0, 1, 0, 0);
        lctx.drawImage(mask, 0, 0);
        lctx.globalCompositeOperation = "source-over";
        return layer;
    }

    function renderContourCanvas() {
        const canvas = document.getElementById("pcsms-preview-contour");
        const layout = getContourLayout();
        if (!canvas || !layout) return;

        const material = state.material || "Black";
        const { face } = layout;
        const faceW = face.offsetWidth;
        const faceH = face.offsetHeight;
        if (!faceW || !faceH) return;

        const canvasW = faceW + CONTOUR_PAD * 2;
        const canvasH = faceH + CONTOUR_PAD * 2;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        canvas.width = Math.ceil(canvasW * dpr);
        canvas.height = Math.ceil(canvasH * dpr);
        canvas.style.width = `${canvasW}px`;
        canvas.style.height = `${canvasH}px`;
        canvas.style.left = `${face.offsetLeft - CONTOUR_PAD}px`;
        canvas.style.top = `${face.offsetTop - CONTOUR_PAD}px`;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const borderMask = buildExpandedMask(
            layout,
            canvas.width,
            canvas.height,
            canvasW,
            canvasH,
            dpr,
            CONTOUR_OFFSET + CONTOUR_BORDER
        );
        const bodyMask = buildExpandedMask(
            layout,
            canvas.width,
            canvas.height,
            canvasW,
            canvasH,
            dpr,
            CONTOUR_OFFSET
        );
        if (!borderMask || !bodyMask) return;

        // White die-cut keyline border is the outer layer; the body color sits inside it.
        const borderColor = material === "Clear" ? "#e9e9ee" : "#ffffff";
        const borderLayer = makeColoredLayer(borderMask, borderColor, canvasW, canvasH, dpr);
        const bodyLayer = makeColoredLayer(
            bodyMask,
            (lctx, w, h) => getBodyFill(lctx, material, w, h),
            canvasW,
            canvasH,
            dpr
        );

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (borderLayer) ctx.drawImage(borderLayer, 0, 0);
        if (bodyLayer) ctx.drawImage(bodyLayer, 0, 0);
    }

    function buildPreviewCanvas() {
        const layout = getContourLayout();
        if (!layout) return null;

        const material = state.material || "Black";
        const { face } = layout;
        const faceW = face.offsetWidth;
        const faceH = face.offsetHeight;
        if (!faceW || !faceH) return null;

        const canvasW = faceW + CONTOUR_PAD * 2;
        const canvasH = faceH + CONTOUR_PAD * 2;
        const scale = Math.min(3, Math.max(1.5, 760 / canvasW));

        const out = document.createElement("canvas");
        out.width = Math.ceil(canvasW * scale);
        out.height = Math.ceil(canvasH * scale);
        const ctx = out.getContext("2d");
        if (!ctx) return null;

        const borderMask = buildExpandedMask(
            layout,
            out.width,
            out.height,
            canvasW,
            canvasH,
            scale,
            CONTOUR_OFFSET + CONTOUR_BORDER
        );
        const bodyMask = buildExpandedMask(
            layout,
            out.width,
            out.height,
            canvasW,
            canvasH,
            scale,
            CONTOUR_OFFSET
        );
        if (!borderMask || !bodyMask) return null;

        const borderColor = material === "Clear" ? "#e9e9ee" : "#ffffff";
        const borderLayer = makeColoredLayer(borderMask, borderColor, canvasW, canvasH, scale);
        const bodyLayer = makeColoredLayer(
            bodyMask,
            (lctx, w, h) => getBodyFill(lctx, material, w, h),
            canvasW,
            canvasH,
            scale
        );

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, out.width, out.height);
        if (borderLayer) ctx.drawImage(borderLayer, 0, 0);
        if (bodyLayer) ctx.drawImage(bodyLayer, 0, 0);

        const { icon, iconBox, atText, nameText, atBox, nameBox, handleFont, letterSpacing } =
            layout;

        ctx.setTransform(scale, 0, 0, scale, 0, 0);

        if (icon && icon.complete && icon.naturalWidth) {
            ctx.drawImage(icon, iconBox.x, iconBox.y, iconBox.w, iconBox.h);
        }

        const textColor = getPreviewTextColor(material, state.letter_color || "Gloss Black");
        ctx.fillStyle = textColor;
        ctx.font = handleFont;
        ctx.textBaseline = "alphabetic";
        if (letterSpacing) ctx.letterSpacing = letterSpacing;
        ctx.fillText(atText, atBox.x, getSpanDrawY(ctx, handleFont, atText, atBox));
        ctx.fillText(nameText, nameBox.x, getSpanDrawY(ctx, handleFont, nameText, nameBox));
        ctx.setTransform(1, 0, 0, 1, 0, 0);

        return out;
    }

    function getPreviewFileName() {
        const handle = (state.username?.trim() || "yourname")
            .toLowerCase()
            .replace(/[^a-z0-9_-]+/g, "-")
            .replace(/^-+|-+$/g, "") || "preview";
        const platform = (state.platform || "social").toLowerCase().replace(/\s+/g, "-");
        return `${platform}-${handle}-sticker.png`;
    }

    function buildPreviewFile() {
        return new Promise((resolve) => {
            const canvas = buildPreviewCanvas();
            if (!canvas) {
                resolve(null);
                return;
            }
            const fileName = getPreviewFileName();
            try {
                canvas.toBlob((blob) => {
                    if (!blob) {
                        resolve(null);
                        return;
                    }
                    resolve(new File([blob], fileName, { type: "image/png" }));
                }, "image/png");
            } catch {
                resolve(null);
            }
        });
    }

    function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
    }

    function getPreviewTextColor(material, letterColor) {
        const hex = COLOR_HEX[letterColor] || "#0f1111";

        if (material === "Black") {
            if (letterColor === "Gloss Black") return "#ffffff";
            return hex;
        }

        if (letterColor === "Gloss Black") return "#0f1111";
        return hex;
    }

    function getCanvasFont(el, fontSize) {
        if (!el) return `700 italic ${fontSize}px sans-serif`;
        const style = getComputedStyle(el);
        return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSize}px ${style.fontFamily}`;
    }

    function getCanvasLetterSpacing(el) {
        if (!el) return "0px";
        const ls = getComputedStyle(el).letterSpacing;
        return ls && ls !== "normal" ? ls : "0px";
    }

    function getContourLayout() {
        const diecut = document.getElementById("pcsms-preview-diecut");
        const face = diecut?.querySelector(".pcsms-preview-diecut-face");
        const icon = document.getElementById("pcsms-preview-icon");
        const atEl = diecut?.querySelector(".pcsms-preview-at");
        const nameEl = document.getElementById("pcsms-preview-name");
        const usernameEl = document.getElementById("pcsms-preview-username");
        if (!diecut || !face || !icon || !atEl || !nameEl || !usernameEl) return null;

        const pad = CONTOUR_PAD;
        const fontSize = getPreviewFontSize();
        const handleFont = getCanvasFont(usernameEl, fontSize);
        const atText = atEl.textContent || "@";
        const nameText = nameEl.textContent || "YOURNAME";
        const letterSpacing = getCanvasLetterSpacing(usernameEl);

        const iconBox = getDomBox(icon, face, pad);
        const atBox = getDomBox(atEl, face, pad);
        const nameBox = getDomBox(nameEl, face, pad);

        return {
            diecut,
            face,
            icon,
            pad,
            fontSize,
            handleFont,
            atText,
            nameText,
            letterSpacing,
            iconBox,
            atBox,
            nameBox,
        };
    }

    function scheduleContourRender() {
        const run = () => requestAnimationFrame(renderContourCanvas);
        const usernameEl = document.getElementById("pcsms-preview-username");
        const fontSpec = usernameEl
            ? getCanvasFont(usernameEl, getPreviewFontSize())
            : null;

        const start = () => {
            const runAll = () => {
                run();
                setTimeout(run, 180);
            };

            if (fontSpec && document.fonts?.load) {
                document.fonts.load(fontSpec).then(runAll).catch(runAll);
            } else if (document.fonts?.ready) {
                document.fonts.ready.then(runAll).catch(runAll);
            } else {
                runAll();
            }
        };

        start();
    }

    function fitPreviewUsername() {
        const usernameEl = document.getElementById("pcsms-preview-username");
        const sticker = document.getElementById("pcsms-preview-sticker");
        const icon = document.getElementById("pcsms-preview-icon");
        if (!usernameEl || !sticker) return;

        usernameEl.style.fontSize = "";

        const iconW = icon ? icon.offsetWidth + 6 : 44;
        const maxTextW = Math.max(80, sticker.clientWidth - iconW - 32);
        let size = 26;

        usernameEl.style.fontSize = `${size}px`;

        while (usernameEl.scrollWidth > maxTextW && size > 9) {
            size -= 0.5;
            usernameEl.style.fontSize = `${size}px`;
        }

        scheduleContourRender();
    }

    function updateLivePreview() {
        const sticker = document.getElementById("pcsms-preview-sticker");
        const stage = document.getElementById("pcsms-preview-stage");
        const usernameEl = document.getElementById("pcsms-preview-username");
        const nameEl = document.getElementById("pcsms-preview-name");
        const iconEl = document.getElementById("pcsms-preview-icon");
        if (!sticker || !usernameEl || !nameEl) return;

        const material = state.material || "Black";
        const materialKey = material.toLowerCase();

        sticker.classList.remove(
            "pcsms-preview-sticker--black",
            "pcsms-preview-sticker--clear",
            "pcsms-preview-sticker--holographic"
        );
        sticker.classList.add(`pcsms-preview-sticker--${materialKey}`);

        if (stage) {
            stage.classList.remove(
                "pcsms-preview-stage--black",
                "pcsms-preview-stage--clear",
                "pcsms-preview-stage--holographic"
            );
            stage.classList.add(`pcsms-preview-stage--${materialKey}`);
        }

        const handle = (state.username?.trim() || "yourname").toUpperCase();
        nameEl.textContent = handle;

        usernameEl.className = "pcsms-preview-username";
        usernameEl.classList.add(getFontClass(state.font));

        const hex = getPreviewTextColor(material, state.letter_color || "Gloss Black");

        usernameEl.classList.remove(
            "pcsms-preview-username--on-black",
            "pcsms-preview-username--holo-dark"
        );
        usernameEl.style.color = hex;
        usernameEl.style.webkitTextFillColor = hex;

        if (material === "Black" && hex === "#ffffff") {
            usernameEl.classList.add("pcsms-preview-username--on-black");
        } else if (state.letter_color === "Gloss Black" && material !== "Black") {
            usernameEl.classList.add("pcsms-preview-username--holo-dark");
        }

        const platformLi = document.querySelector(
            `#social-media-select li[data-value="${CSS.escape(state.platform || "Facebook")}"]`
        );
        const platformImg = platformLi?.querySelector("img");
        if (iconEl && platformImg) {
            iconEl.crossOrigin = "anonymous";
            iconEl.onload = scheduleContourRender;
            iconEl.onerror = scheduleContourRender;
            iconEl.src = platformImg.src;
        } else if (iconEl?.complete) {
            scheduleContourRender();
        }

        requestAnimationFrame(fitPreviewUsername);
    }

    function setupPreviewStickyOffset() {
        const wrap = document.getElementById("pcsms-preview-wrap");
        if (!wrap) return;

        const sync = () => {
            const root = getComputedStyle(document.documentElement);
            const headerH =
                parseFloat(root.getPropertyValue("--header-height")) || 0;
            const announceH =
                parseFloat(root.getPropertyValue("--announcement-bar-height")) || 0;
            const stickyHeader =
                parseFloat(root.getPropertyValue("--enable-sticky-header")) || 0;
            const stickyAnnounce =
                parseFloat(root.getPropertyValue("--enable-sticky-announcement-bar")) || 0;
            const top = headerH * stickyHeader + announceH * stickyAnnounce + 8;
            wrap.style.setProperty("--pcsms-preview-sticky-top", `${top}px`);
        };

        sync();
        window.addEventListener("resize", sync);
        if (typeof ResizeObserver !== "undefined") {
            const header = document.querySelector("store-header, .header");
            if (header) new ResizeObserver(sync).observe(header);
        }
    }

    function setupPreviewResize() {
        let raf = 0;
        const onResize = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                fitPreviewUsername();
                scheduleContourRender();
            });
        };
        window.addEventListener("resize", onResize);
        if (typeof ResizeObserver !== "undefined") {
            const diecut = document.getElementById("pcsms-preview-diecut");
            if (diecut) new ResizeObserver(onResize).observe(diecut);
        }
    }

    function setColorDropdownHeader(header, colorName, hex) {
        header.textContent = colorName;
        header.style.setProperty("--swatch", hex);
    }

    function setImageDropdownHeader(header, optionEl) {
        const img = optionEl.querySelector("img");
        const label = optionEl.textContent.trim();
        header.innerHTML = "";
        if (img) {
            const clone = img.cloneNode(true);
            clone.setAttribute("width", "24");
            clone.setAttribute("height", "24");
            header.appendChild(clone);
            header.appendChild(document.createTextNode(` ${label}`));
        } else {
            header.textContent = label;
        }
    }

    function updateBuyBar(total) {
        const labelEl = document.getElementById("pcsms-total-label");
        if (labelEl) {
            const pack = state.creator_kit
                ? `Creator Kit · ${state.creator_kit.count} stickers`
                : state.pack_size || "Single";
            labelEl.textContent = `TOTAL · ${pack.toUpperCase()}`;
        }

        const shippingWrap = document.getElementById("pcsms-shipping");
        const fillEl = document.getElementById("pcsms-shipping-fill");
        const textEl = document.getElementById("pcsms-shipping-text");
        if (!shippingWrap || !fillEl) return;

        const toFree = FREE_SHIP_THRESHOLD - total;
        if (toFree <= 0) {
            shippingWrap.classList.add("is-free");
            if (textEl) {
                textEl.innerHTML = "You unlocked <strong>free shipping</strong>";
            }
            fillEl.style.width = "100%";
        } else {
            shippingWrap.classList.remove("is-free");
            if (textEl) {
                textEl.innerHTML = `Add <strong id="pcsms-shipping-amount">$${toFree.toFixed(
                    2
                )}</strong> more for <strong>free shipping</strong>`;
            }
            const pct = Math.min(
                100,
                Math.round(
                    ((FREE_SHIP_THRESHOLD - toFree) / FREE_SHIP_THRESHOLD) * 100
                )
            );
            fillEl.style.width = `${pct}%`;
        }
    }

    function updateUpgradeMaterialVisibility() {
        const basicWrapper = document.getElementById("basic-upgrade-materials");
        const holoWrapper = document.getElementById("holo-upgrade-materials");
        const usingHolo = state.material === "Holographic";

        if (usingHolo) {
            hide(basicWrapper);
            show(holoWrapper);
        } else {
            show(basicWrapper);
            hide(holoWrapper);
        }

        const visibleWrapper = usingHolo ? holoWrapper : basicWrapper;
        let active = visibleWrapper.querySelector(".sticker-variant.active");
        if (!active) {
            active = visibleWrapper.querySelector(".sticker-variant");
            if (active) active.classList.add("active");
        }

        if (active) state.upgrade_material = active.dataset.material;
        recalcPrice();
    }

    function setupMaterialSelection() {
        const materialWrapper = document.getElementById("material-variant");
        materialWrapper.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected) return;
            event.preventDefault();

            materialWrapper
                .querySelectorAll(".sticker-variant")
                .forEach((el) => el.classList.toggle("active", el === selected));

            state.material = selected.dataset.material;
            updateUpgradeMaterialVisibility();
            updateLivePreview();
        });
    }

    function setupUpgradeMaterialSelection() {
        const upgradeSection = document.getElementById("upgrade-material-variant");
        upgradeSection.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected) return;
            event.preventDefault();

            const parentWrapper = selected.closest(".pcsms-upgrade-list");
            if (!parentWrapper || getComputedStyle(parentWrapper).display === "none") return;

            parentWrapper
                .querySelectorAll(".sticker-variant")
                .forEach((el) => el.classList.toggle("active", el === selected));

            state.upgrade_material = selected.dataset.material;
            recalcPrice();
        });
    }

    function setupPackSizeSelection() {
        const packWrapper = document.getElementById("pack-size-list");
        if (!packWrapper) return;

        packWrapper.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected) return;
            event.preventDefault();

            packWrapper
                .querySelectorAll(".sticker-variant")
                .forEach((el) => el.classList.toggle("active", el === selected));

            state.pack_size = selected.dataset.pack;
            deselectCreatorKit();

            const variantBox = document.getElementById("pack-size-variant");
            if (variantBox) {
                variantBox.classList.remove("has-error");
                const errorBar = document.getElementById("pack-size-error-bar");
                if (errorBar) errorBar.style.display = "none";
            }

            recalcPrice();
        });
    }

    function discountForQty(qty) {
        const q = parseInt(qty, 10) || 0;
        const tier = KIT_DISCOUNT_TIERS.find((t) => q >= t.min);
        return tier ? tier.disc : 0;
    }

    function computeKitPricing(sets) {
        const n = Math.min(4, Math.max(1, parseInt(sets, 10) || 1));

        // Each size is priced from its decal length only (material is added later
        // in the running total), discounted by how many of that size are ordered.
        let price = 0;
        let fullPrice = 0;
        KIT_SET_COMPOSITION.forEach((item) => {
            const qty = item.qty * n;
            const lineFull = priceOf("decal_length", item.decal) * qty;
            fullPrice += lineFull;
            price += lineFull * (1 - discountForQty(qty));
        });

        price = Math.round(price * 100) / 100;
        fullPrice = Math.round(fullPrice * 100) / 100;
        const count = KIT_STICKERS_PER_SET * n;
        const savings = Math.max(0, Math.round((fullPrice - price) * 100) / 100);
        return {
            sets: n,
            count,
            price,
            perSticker: price / count,
            savings,
            prop: KIT_SET_PROP[n],
        };
    }

    function renderKitSetPrices() {
        const grid = document.getElementById("creator-kit-sets-grid");
        if (!grid) return;

        grid.querySelectorAll(".pcsms-kit-set").forEach((btn) => {
            const pricing = computeKitPricing(btn.dataset.sets);
            btn.dataset.price = pricing.price.toFixed(2);
            btn.dataset.count = String(pricing.count);
            btn.dataset.prop = pricing.prop;

            const priceEl = btn.querySelector(".pcsms-kit-set-price");
            if (priceEl) priceEl.textContent = `$${pricing.price.toFixed(2)}`;

            const countEl = btn.querySelector(".pcsms-kit-set-count");
            if (countEl) countEl.textContent = `${pricing.count} stickers`;

            let saveEl = btn.querySelector(".pcsms-kit-set-save");
            if (pricing.savings >= 1) {
                if (!saveEl) {
                    saveEl = document.createElement("span");
                    saveEl.className = "pcsms-kit-set-save";
                    btn.appendChild(saveEl);
                }
                saveEl.textContent = `Save $${pricing.savings.toFixed(2)}`;
            } else if (saveEl) {
                saveEl.remove();
            }
        });
    }

    function updateKitSetDisplay() {
        const unitEl = document.querySelector("#creator-kit .pcsms-kit-sets-unit");
        const footEl = document.querySelector("#creator-kit .pcsms-kit-inside-foot");
        const amountEl = document.getElementById("creator-kit-price-amount");
        const cardUnitEl = document.querySelector("#creator-kit .pcsms-kit-price-unit");
        const check = `<span class="pcsms-kit-check" aria-hidden="true">✓</span>`;

        const kit = state.creator_kit;
        const pricing = computeKitPricing(kit ? kit.sets : 1);
        const { count, sets, price, perSticker } = pricing;
        const setWord = sets === 1 ? "set" : "sets";

        if (unitEl) unitEl.textContent = `$${perSticker.toFixed(2)} / sticker`;
        if (cardUnitEl) cardUnitEl.textContent = `$${perSticker.toFixed(2)} / sticker`;
        if (amountEl) amountEl.textContent = `$${price.toFixed(2)}`;
        if (footEl) {
            footEl.innerHTML = `${check} ${count} stickers · same handle (${sets}× ${setWord})`;
        }

        document.querySelectorAll("#creator-kit .pcsms-kit-qty").forEach((el) => {
            const base = parseInt(el.dataset.base, 10) || 1;
            el.textContent = `${base * sets}×`;
        });
    }

    function deselectCreatorKit() {
        state.creator_kit = null;
        const wrap = document.getElementById("creator-kit");
        const card = document.getElementById("creator-kit-card");
        const setsWrap = document.getElementById("creator-kit-sets");
        if (wrap) wrap.classList.remove("is-active");
        if (card) card.setAttribute("aria-expanded", "false");
        if (setsWrap) setsWrap.hidden = true;
        updateKitSetDisplay();
    }

    function setupCreatorKit() {
        const card = document.getElementById("creator-kit-card");
        const wrap = document.getElementById("creator-kit");
        const setsWrap = document.getElementById("creator-kit-sets");
        const grid = document.getElementById("creator-kit-sets-grid");
        if (!card || !wrap || !setsWrap || !grid) return;

        renderKitSetPrices();
        updateKitSetDisplay();

        function selectKit(setKey) {
            const packWrapper = document.getElementById("pack-size-list");
            if (packWrapper) {
                packWrapper
                    .querySelectorAll(".sticker-variant")
                    .forEach((el) => el.classList.remove("active"));
            }
            state.pack_size = null;

            wrap.classList.add("is-active");
            card.setAttribute("aria-expanded", "true");
            setsWrap.hidden = false;

            const key = setKey || String(state.creator_kit?.sets || "1");
            const btn =
                grid.querySelector(`.pcsms-kit-set[data-sets="${key}"]`) ||
                grid.querySelector(".pcsms-kit-set");
            grid.querySelectorAll(".pcsms-kit-set").forEach((b) =>
                b.classList.toggle("active", b === btn)
            );

            const pricing = computeKitPricing(btn.dataset.sets);
            state.creator_kit = {
                sets: pricing.sets,
                count: pricing.count,
                price: pricing.price,
                prop: pricing.prop,
            };
            updateKitSetDisplay();

            const variantBox = document.getElementById("pack-size-variant");
            if (variantBox) variantBox.classList.remove("has-error");
            const errorBar = document.getElementById("pack-size-error-bar");
            if (errorBar) errorBar.style.display = "none";

            recalcPrice();
        }

        card.addEventListener("click", (event) => {
            event.preventDefault();
            selectKit();
        });

        grid.addEventListener("click", (event) => {
            const btn = event.target.closest(".pcsms-kit-set");
            if (!btn) return;
            event.preventDefault();
            selectKit(btn.dataset.sets);
        });
    }

    function setupLetterColorSelection() {
        const list = document.getElementById("letter-color-list");
        const nameEl = document.getElementById("pcsms-selected-color-name");
        if (!list) return;

        list.addEventListener("click", (event) => {
            const swatch = event.target.closest(".pcsms-letter-swatch");
            if (!swatch) return;
            event.preventDefault();

            list.querySelectorAll(".pcsms-letter-swatch").forEach((el) => {
                const active = el === swatch;
                el.classList.toggle("active", active);
                el.setAttribute("aria-selected", active ? "true" : "false");
            });

            state.letter_color = swatch.dataset.color;
            if (nameEl) nameEl.textContent = swatch.dataset.color;
            updateLivePreview();
        });
    }

    function setupAddonToggle(wrapperId, stateKey, offValue, onValue, onSelector) {
        const wrapper = document.getElementById(wrapperId);
        if (!wrapper) return;

        const offEl = wrapper.querySelector(".sticker-variant.pcsms-sr-only");
        const onEl = wrapper.querySelector(onSelector);
        if (!offEl || !onEl) return;

        wrapper.addEventListener("click", (event) => {
            const row = event.target.closest(".pcsms-addon-row");
            if (!row) return;
            event.preventDefault();

            const isOn = onEl.classList.contains("active");
            offEl.classList.toggle("active", isOn);
            onEl.classList.toggle("active", !isOn);
            state[stateKey] = isOn ? offValue : onValue;
            recalcPrice();
        });
    }

    function initDropdownDefaults() {
        document.querySelectorAll(".select-dropdown").forEach((dd) => {
            const preSel = dd.querySelector("li.selected");
            if (!preSel) return;

            const header = dd.querySelector(".selected-text");
            const stateKey = dd.dataset.stateKey;

            if (stateKey === "platform") {
                setImageDropdownHeader(header, preSel);
                state.platform = preSel.dataset.value;
            } else if (stateKey === "font") {
                header.textContent = preSel.textContent.trim();
                preSel.classList.forEach((cls) => {
                    if (cls.startsWith("font-")) header.classList.add(cls);
                });
                state.font = preSel.dataset.value;
            } else {
                header.textContent = getOptionDisplayText(preSel);
                if (stateKey && preSel.dataset.value) {
                    state[stateKey] = preSel.dataset.value;
                }
            }
        });
    }

    function dropdownClickHandler(evt) {
        const dropdown = evt.target.closest(".select-dropdown");

        if (!dropdown) {
            document
                .querySelectorAll(".dropdown-options")
                .forEach((list) => (list.style.display = "none"));
            return;
        }

        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        const stateKey =
            dropdown.dataset.stateKey || dropdown.id.replace(/-select$/, "");
        const optionEl = evt.target.closest("li[data-value]");

        document.querySelectorAll(".dropdown-options").forEach((other) => {
            if (other !== list) other.style.display = "none";
        });

        if (optionEl) {
            const value = optionEl.dataset.value;

            list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
            optionEl.classList.add("selected");
            dropdown.classList.add("variant-picked");

            if (stateKey === "font") {
                header.textContent = optionEl.textContent.trim();
                header.classList.forEach((cls) => {
                    if (cls.startsWith("font-")) header.classList.remove(cls);
                });
                optionEl.classList.forEach((cls) => {
                    if (cls.startsWith("font-")) header.classList.add(cls);
                });
            } else if (stateKey === "platform") {
                setImageDropdownHeader(header, optionEl);
            } else {
                header.textContent = getOptionDisplayText(optionEl);
            }

            if (stateKey) state[stateKey] = value;

            if (stateKey === "platform" || stateKey === "font") updateLivePreview();

            const variantBox = dropdown.closest(".pcsms-variant");
            if (variantBox) {
                variantBox.classList.remove("has-error");
                const errorBar = variantBox.querySelector(".error-bar");
                if (errorBar) errorBar.style.display = "none";
            }

            list.style.display = "none";
            recalcPrice();
            return;
        }

        list.style.display = list.style.display === "block" ? "none" : "block";
    }

    function handleUsernameInput() {
        const input = document.getElementById("username-input");
        if (!input || input.dataset.listenerAttached) return;
        input.dataset.listenerAttached = "true";

        const counter = document.getElementById("username-char-count");
        const error = document.getElementById("username-error-bar");
        const MAX = 30;
        const ALLOWED_PATTERN = /[^A-Za-z0-9._-]+/g;

        const refresh = () => {
            const cleaned = input.value.replace(ALLOWED_PATTERN, "").slice(0, MAX);
            if (cleaned !== input.value) input.value = cleaned;

            state.username = cleaned;
            counter.textContent = `${MAX - cleaned.length} character(s) left`;
            error.style.display = "none";
            updateLivePreview();
        };

        refresh();
        input.addEventListener("input", refresh);
    }

    function validateForm() {
        let firstInvalid = null;

        function toggleError(id, showError) {
            const bar = document.getElementById(id);
            if (!bar) return;

            bar.style.display = showError ? "block" : "none";
            const variantBox = bar.closest(".pcsms-variant");
            if (variantBox) variantBox.classList.toggle("has-error", showError);
            if (showError && !firstInvalid) firstInvalid = variantBox || bar;
        }

        state.username = document.getElementById("username-input").value.trim();

        toggleError("social-media-error-bar", !state.platform);
        toggleError("username-error-bar", !state.username);
        toggleError("decal-length-error-bar", !state.decal_length);
        toggleError("pack-size-error-bar", !state.pack_size && !state.creator_kit);

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
        }
        return true;
    }

    function updatePackSavings() {
        const packWrapper = document.getElementById("pack-size-list");
        if (!packWrapper) return;

        const perSticker = priceOf("material", state.material) || 0;

        packWrapper.querySelectorAll(".sticker-variant").forEach((btn) => {
            const slot = btn.querySelector(".pcsms-pack-badge-slot");
            if (!slot) return;

            // Leave the highlighted "Best Value" row's badge untouched.
            if (btn.classList.contains("pcsms-pack-row--gold")) return;

            const packName = btn.dataset.pack || "";
            const qty = packName === "Single" ? 1 : parseInt(packName, 10) || 1;
            const addon = parseFloat(btn.dataset.price) || 0;
            const savings = qty * perSticker - addon;

            if (qty > 1 && savings >= 1) {
                slot.removeAttribute("aria-hidden");
                slot.innerHTML = `<span class="pcsms-badge pcsms-badge--save">Save $${savings.toFixed(
                    2
                )}</span>`;
            } else {
                slot.setAttribute("aria-hidden", "true");
                slot.innerHTML = "";
            }
        });
    }

    function priceOf(groupKey, chosenValue) {
        if (!chosenValue) return 0;
        const list = PRICE_VARIANTS[groupKey] || [];
        const found = list.find((item) => item.value === chosenValue);
        return found ? found.price : 0;
    }

    function recalcPrice() {
        let total = 0;

        const upgrKey =
            state.material === "Holographic"
                ? "upgrade_material_holo"
                : "upgrade_material_basic";

        // Material, finish upgrade and finishing add-ons apply in every
        // configuration and are summed into the running total at the end.
        total += priceOf("material", state.material);
        total += priceOf(upgrKey, state.upgrade_material);
        total += priceOf("lamination", state.lamination);
        total += priceOf("install_kit", state.install_kit);

        // The Creator Deployment Kit price covers the decal sizes (discounted by
        // quantity); it replaces the decal-length and pack-size lines when active.
        // Material is still added above, so everything adds up in the total.
        if (state.creator_kit) {
            total += state.creator_kit.price;
        } else {
            total += priceOf("decal_length", state.decal_length);
            total += priceOf("pack_size", state.pack_size);
        }

        const priceEl = document.getElementById("pcsms-final-price");
        const prevValue = parseFloat(priceEl.textContent) || 0;
        const newValue = total;

        if (prevValue !== newValue) {
            animatePriceChange(priceEl, prevValue, newValue);
        }

        state.price = newValue;
        updateBuyBar(newValue);
        updatePackSavings();
    }

    function resetCalculatorForm() {
        state.material = "Black";
        state.platform = "Facebook";
        state.font = "Anton";
        state.letter_color = "Gloss Black";
        state.username = null;
        state.decal_length = "10 Inches Long";
        state.pack_size = "5 Pack";
        state.creator_kit = null;
        state.upgrade_material = "Gloss";
        state.lamination = "No Lamination";
        state.install_kit = "No install kit";
        state.price = 0;

        const materialWrapper = document.getElementById("material-variant");
        materialWrapper
            .querySelectorAll(".sticker-variant")
            .forEach((el, index) => {
                el.classList.toggle("active", index === 0);
            });

        const basicUpgrades = document.getElementById("basic-upgrade-materials");
        const holoUpgrades = document.getElementById("holo-upgrade-materials");

        if (basicUpgrades) {
            basicUpgrades
                .querySelectorAll(".sticker-variant")
                .forEach((el, index) => {
                    el.classList.toggle("active", index === 0);
                });
        }
        if (holoUpgrades) {
            holoUpgrades
                .querySelectorAll(".sticker-variant")
                .forEach((el, index) => {
                    el.classList.toggle("active", index === 0);
                });
        }
        holoUpgrades.style.display = "none";
        basicUpgrades.style.display = "";

        document.querySelectorAll(".select-dropdown").forEach((dd) => {
            const firstOption = dd.querySelector("li[data-value].selected") ||
                dd.querySelector("li[data-value]");
            if (!firstOption) return;

            const header = dd.querySelector(".selected-text");
            const stateKey = dd.dataset.stateKey;

            dd.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
            firstOption.classList.add("selected");

            if (stateKey === "platform") {
                setImageDropdownHeader(header, firstOption);
            } else if (stateKey === "font") {
                header.textContent = firstOption.textContent.trim();
                header.classList.forEach((cls) => {
                    if (cls.startsWith("font-")) header.classList.remove(cls);
                });
                firstOption.classList.forEach((cls) => {
                    if (cls.startsWith("font-")) header.classList.add(cls);
                });
            } else {
                header.textContent = getOptionDisplayText(firstOption);
            }

            dd.classList.remove("variant-picked");
            const options = dd.querySelector(".dropdown-options");
            if (options) options.style.display = "none";
        });

        const colorList = document.getElementById("letter-color-list");
        const colorNameEl = document.getElementById("pcsms-selected-color-name");
        if (colorList) {
            colorList.querySelectorAll(".pcsms-letter-swatch").forEach((el, index) => {
                const active = index === 0;
                el.classList.toggle("active", active);
                el.setAttribute("aria-selected", active ? "true" : "false");
            });
        }
        if (colorNameEl) colorNameEl.textContent = "Gloss Black";

        const usernameInput = document.getElementById("username-input");
        if (usernameInput) {
            usernameInput.value = "";
            document.getElementById("username-char-count").textContent =
                "30 character(s) left";
        }

        const packWrapper = document.getElementById("pack-size-list");
        if (packWrapper) {
            packWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.toggle("active", el.dataset.pack === "5 Pack");
            });
        }
        deselectCreatorKit();
        const kitGrid = document.getElementById("creator-kit-sets-grid");
        if (kitGrid) {
            kitGrid.querySelectorAll(".pcsms-kit-set").forEach((b, index) =>
                b.classList.toggle("active", index === 0)
            );
        }

        ["#lamination-variant", "#install-kit-variant"].forEach((sel) => {
            const section = document.querySelector(sel);
            if (!section) return;
            section
                .querySelectorAll(".sticker-variant")
                .forEach((v) => v.classList.remove("active"));
            const offVariant = section.querySelector(".sticker-variant.pcsms-sr-only");
            if (offVariant) offVariant.classList.add("active");
        });

        document.querySelectorAll(".error-bar").forEach((el) => {
            el.style.display = "none";
        });
        document.querySelectorAll(".pcsms-variant").forEach((el) => {
            el.classList.remove("has-error");
        });

        updateUpgradeMaterialVisibility();
        updateLivePreview();
        recalcPrice();
    }

    function setupApippaAddToCart() {
        const addToCartBtn = document.getElementById("pcsms-add-to-cart");
        if (!addToCartBtn || addToCartBtn.dataset.bound) return;
        addToCartBtn.dataset.bound = "true";

        addToCartBtn.addEventListener("click", async (e) => {
            e.preventDefault();

            if (!validateForm()) return;

            addToCartBtn.classList.remove("shine");
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add("loading");
            addToCartBtn.innerHTML = PCSMS_CART_LOADING_HTML;

            try {
                const previewFile = await buildPreviewFile();

                const requestData = {
                    calculatorId: "bea6985e21d44",
                    productId: 7693731037232,
                    properties: {
                        Material: state.material,
                        "Social Media": state.platform || "",
                        Font: state.font,
                        "Letter color": state.letter_color,
                        Username: state.username || "",
                        "Decal Length": state.decal_length,
                        "UPGRADE MATERIAL": state.upgrade_material,
                        "Add PRO-MAX Lamination": state.lamination,
                        "ADD INSTALL KIT?": state.install_kit,
                    },
                };

                if (state.creator_kit) {
                    requestData.properties["Decal Length"] = "Creator Deployment Kit";
                    requestData.properties["Pack Size"] = "Creator Deployment Kit";
                    requestData.properties["Creator Deployment Kit"] =
                        state.creator_kit.prop;
                } else {
                    requestData.properties["Pack Size"] = state.pack_size;
                    // Apippa requires EVERY configured option in each variant
                    // request, so the Creator Deployment Kit option must always be
                    // present. Send its neutral $0 "None" value when no kit chosen.
                    requestData.properties["Creator Deployment Kit"] = "None";
                }

                if (previewFile) {
                    requestData.properties["Upload Image"] = previewFile.name;
                }

                const variantRes = await fetch(
                    "https://api.custompricecalculator.com/api/v1/variant",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    }
                );

                const variantId = await variantRes.json();
                const shopifyVariantId =
                    typeof variantId === "string"
                        ? variantId
                        : variantId?.variantId || variantId?.id;

                if (!shopifyVariantId) throw new Error("Invalid variant ID");

                const formData = new FormData();
                formData.append("id", shopifyVariantId);
                formData.append("quantity", 1);

                Object.entries(requestData.properties).forEach(([key, value]) => {
                    formData.append(`properties[${key}]`, value);
                });

                if (previewFile) {
                    formData.append("properties[Upload Image]", previewFile);
                }

                const cartAddRes = await fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                });

                const cartAddJson = await cartAddRes.json();
                if (!cartAddRes.ok) throw new Error("Failed to add to cart");

                localStorage.setItem(
                    `patched-cart-item-${cartAddJson.id}`,
                    JSON.stringify({
                        id: cartAddJson.id,
                        title: cartAddJson.product_title,
                        image: cartAddJson.image,
                        price: cartAddJson.price,
                    })
                );

                const cartJson = {
                    items: [cartAddJson],
                    item_count: 1,
                    total_price: cartAddJson.final_price,
                    original_total_price: cartAddJson.original_price,
                    total_discount: 0,
                };

                const timestamp = new Date().getTime();
                await new Promise((resolve) => setTimeout(resolve, 200));
                const sectionHtml = await fetch(
                    `/cart?section_id=mini-cart&t=${timestamp}`
                ).then((res) => res.text());

                const fakeDiv = document.createElement("div");
                fakeDiv.innerHTML = sectionHtml;
                const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;

                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && miniCartHTML) {
                    cartDrawer.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                cart: {
                                    ...cartJson,
                                    sections: { "mini-cart": miniCartHTML },
                                },
                                openMiniCart: true,
                            },
                        })
                    );
                }

                setTimeout(() => {
                    const lineItems = cartDrawer?.querySelectorAll("line-item") || [];
                    lineItems.forEach((lineItem) => {
                        const desktopPriceContainer = lineItem.querySelector(
                            ".line-item__price-list-container .price"
                        );
                        const mobilePriceContainer = lineItem.querySelector(
                            ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
                        );
                        if (!desktopPriceContainer && !mobilePriceContainer) return;

                        const priceText = (
                            desktopPriceContainer || mobilePriceContainer
                        ).textContent.trim();
                        const isFree = /Free|\$0\.00/.test(priceText);

                        let variantIdFromDom;
                        const productLink = lineItem.querySelector("a[href*='?variant=']");
                        if (productLink?.href.includes("variant=")) {
                            variantIdFromDom = productLink.href
                                .split("variant=")[1]
                                .split("&")[0];
                        }
                        if (!variantIdFromDom) {
                            const removeBtn = lineItem.querySelector(
                                "a[href*='/cart/change?id=']"
                            );
                            const match = removeBtn?.getAttribute("href")?.match(/id=(\d+):/);
                            variantIdFromDom = match?.[1];
                        }

                        if (isFree && variantIdFromDom == shopifyVariantId) {
                            const correctPrice = (cartAddJson.price / 100).toFixed(2);
                            const updatedPriceHTML = `<span class="visually-hidden">Sale price</span>$${correctPrice}`;
                            if (desktopPriceContainer) {
                                desktopPriceContainer.innerHTML = updatedPriceHTML;
                            }
                            if (mobilePriceContainer) {
                                mobilePriceContainer.innerHTML = updatedPriceHTML;
                            }
                        }
                    });
                }, 300);

                setTimeout(async () => {
                    const cartCountData = await fetch("/cart.js").then((res) => res.json());
                    const cartCountEl = document.querySelector("cart-count");
                    if (cartCountEl) cartCountEl.textContent = cartCountData.item_count;
                }, 300);

                setTimeout(async () => {
                    const drawerContent = document.querySelector(
                        "#shopify-section-mini-cart .drawer__content"
                    );
                    if (!drawerContent) return;

                    if (!customElements.get("dotlottie-player")) {
                        await new Promise((res) => {
                            const s = document.createElement("script");
                            s.src =
                                "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js";
                            s.onload = res;
                            document.head.appendChild(s);
                        });
                    }

                    const confetti = document.createElement("dotlottie-player");
                    confetti.className = "mini-cart-lottie";
                    confetti.src =
                        "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
                    confetti.setAttribute("background", "transparent");
                    confetti.setAttribute("speed", "1");
                    confetti.setAttribute("style", "width: 300px; height: 300px");
                    confetti.setAttribute("direction", "1");
                    confetti.setAttribute("playmode", "normal");
                    confetti.setAttribute("autoplay", "");
                    drawerContent.prepend(confetti);
                    setTimeout(() => confetti.remove(), 3000);
                }, 1000);
            } catch (err) {
                console.error("Apippa Add to Cart Error:", err);
                alert("There was a problem adding your item to the cart.");
            } finally {
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove("loading");
                addToCartBtn.innerHTML = PCSMS_CART_BTN_HTML;
                resetCalculatorForm();
            }
        });
    }

    function playCartButtonShine() {
        const btn = document.getElementById("pcsms-add-to-cart");
        if (!btn || btn.classList.contains("loading")) return;
        btn.classList.remove("shine");
        void btn.offsetWidth;
        btn.classList.add("shine");
    }

    function setupCartButtonShine() {
        const btn = document.getElementById("pcsms-add-to-cart");
        if (!btn || btn.dataset.shineBound) return;
        btn.dataset.shineBound = "true";
        setTimeout(playCartButtonShine, 1500);
        setInterval(playCartButtonShine, 5000);
    }


    setupMaterialSelection();
    setupUpgradeMaterialSelection();
    setupPackSizeSelection();
    setupCreatorKit();
    setupLetterColorSelection();
    setupPreviewResize();
    setupPreviewStickyOffset();
    setupAddonToggle(
        "lamination-variant",
        "lamination",
        "No Lamination",
        "YES ADD LAM- Recommend if used on cars",
        '[data-material="YES ADD LAM- Recommend if used on cars"]'
    );
    setupAddonToggle(
        "install-kit-variant",
        "install_kit",
        "No install kit",
        "Add install kit",
        '[data-material="Add install kit"]'
    );
    updateUpgradeMaterialVisibility();
    initDropdownDefaults();
    handleUsernameInput();
    setupApippaAddToCart();
    setupCartButtonShine();
    document.addEventListener("click", dropdownClickHandler);
    updateLivePreview();
    recalcPrice();
});
